import {Component, OnInit} from '@angular/core';
import {Group} from '../../../../../models/group.model';
import {Position} from '../../../../../models/position.model';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../../services/admin.service';
import {Response} from '@angular/http';
import {GroupUser} from '../../../../../models/group-user.model';

@Component({
  selector: 'app-change-user-position',
  templateUrl: './change-user-position.component.html',
  styleUrls: ['./change-user-position.component.css']
})
export class ChangeUserPositionComponent implements OnInit {
  public group: Group;
  public selectedPosition: Position;
  public selectedUserName;
  public selectedUserId;
  public successInfo = false;
  public errorInfo = false;
  public errorSix = false; // 406
  public errorTwelve = false; // 412

  // private posList: any[] = [];
  private prevPos;

  public allPositions;

  disabledBtn = false;
  user: GroupUser;

  constructor(public activeModal: NgbActiveModal,
              private adminService: AdminService) {
  }

  ngOnInit() {
    this.adminService.getActivePositions().subscribe(
      (res: any) => {
        this.allPositions = res.body;
        this.selectedPosition = this.allPositions[0];
      },
      () => {
      }
    );
  }

  setPrevPos(prevPos) {
    this.prevPos = prevPos;
  }


  selectedP(newPosition) {
    this.selectedPosition = newPosition;
    this.successInfo = false;
    this.errorInfo = false;
  }

  setGroup(group: Group) {
    this.group = group;
  }

  setUserPosData(user: GroupUser) {
    this.user = user;
    this.selectedUserId = user.user.id;
    this.selectedUserName = user.user.firstName + ' ' + user.user.lastName;
    this.selectedPosition = user.position;

  }

  setPos() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;
    this.errorSix = false; // 406
    this.errorTwelve = false; // 412

    this.adminService.changeUserPositionInGroup(this.group.id, this.selectedUserId, this.selectedPosition.id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.user.position = this.selectedPosition;

          // *********************
          // let v = false;
          // this.posList.forEach(i => {
          //   if (i.name === this.selectedPosition.name) {
          //     v = true;
          //   }
          // });
          //
          // if (!v) {
          //   this.posList.push(this.selectedPosition);
          // }

          // *********************

          // let ct = 0;
          // this.posList.forEach(i => {
          //   if (i.name === this.prevPos.name) {
          //     ct++;
          //   }
          // });
          //
          // if (ct < 2 && ct > 0) {
          //   const a = this.posList.indexOf(this.prevPos);
          //   this.posList.splice(a, 1);
          // }

          // *********************

          this.successInfo = true;
          this.errorInfo = false;
          this.errorSix = false; // 406

          this.errorTwelve = false; // 412
          this.disabledBtn = false;
        }
      },
      (error) => {
        if (error.status === 406) {
          // 406 - указанного юзера или указанной позиции нет этой группе
          this.successInfo = false;
          this.errorInfo = false;
          this.errorSix = true; // 406
          this.errorTwelve = false; // 412
        }
        if (error.status === 412) {
          // 412 - юзера, группы, или позиции с такими айди в базе не найдено
          this.successInfo = false;
          this.errorInfo = false;
          this.errorSix = false; // 406
          this.errorTwelve = true; // 412
        }
        this.successInfo = false;
        this.errorInfo = true;
        this.errorSix = false; // 406
        this.errorTwelve = false; // 412
        this.disabledBtn = false;
      });
  }

  filterBy(prop: string) {
    if (this.allPositions !== undefined) {
      return this.allPositions.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
    }
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-group/popups/change-user-position/change-user-position.component.ts